<!-- app-context-menu.component.html -->
<div class="context-menu" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()" [style.left.px]="contextMenuPosition.x" [style.top.px]="contextMenuPosition.y">
    <ul>
      <li (click)="rename(contextMenuDirectory)">
        <i class="fa-solid fa-pen text-primary"></i> Renombrar
      </li>
      <li (click)="add(contextMenuDirectory)" *ngIf="allowSubdirectory(contextMenuDirectory)">
        <i class="fa-solid fa-folder-plus text-warning"></i> Nuevo
      </li>
      <li (click)="del(contextMenuDirectory)">
        <i class="fa-solid fa-trash text-danger"></i> Eliminar
      </li>
    </ul>
  </div>
  